import { toBoolean } from 'utils/string';

export const editLotEnabled = toBoolean(process.env.REACT_APP_EDIT_LOT_ENABLED);
